// export { default as Register } from './register/register';
// export { default as Login } from './login/login';
// export { default as Unauthorized } from './Unauthorized/Unauthorized';
// export { default as Error404Page } from './404/Error404Page';
// export { default as ForgotPassword } from './forgot-password/index';
// export { default as VerifyEmail } from './verify-email/index';
// export { default as SetNewPassword } from './set-new-password/index';
// export { default as GoogleCallback } from './google/GoogleCallback';
import { lazy } from 'react';

export const Register = lazy(() => import('./register/register'));
export const Login = lazy(() => import('./login/login'));
export const Unauthorized = lazy(() => import('./Unauthorized/Unauthorized'));
export const Error404Page = lazy(() => import('./404/Error404Page'));
export const ForgotPassword = lazy(() => import('./forgot-password/index'));
export const VerifyEmail = lazy(() => import('./verify-email/index'));
export const SetNewPassword = lazy(() => import('./set-new-password/index'));
export const GoogleCallback = lazy(() => import('./google/GoogleCallback'));